module.exports = __webpack_public_path__ + "static/media/client-area-user-data.7158f57a.svg";